<template>
  <transition name="modal">
    <div class="ui-g modal-mask">
      <div class="ui-g-6 ui-md-4 sm-hide banner align-left" ref="popupTop">
        <h4>Work Showcase</h4>
      </div>
      <div class="ui-g-6 ui-md-8 ui-sm-12 banner align-right">
        <button class="ui-g-float-right sm-hide" v-on:click="close()">CLOSE WINDOW</button>
        <button class="ui-g-float-right xl-hide lg-hide md-hide" v-on:click="close()">CLOSE</button>
        <a v-on:click="nextClient('next')">
          <i class="fas fa-chevron-right ui-g-float-right md-hide sm-hide xs-hide right"></i>
        </a>
        <a v-on:click="nextClient('prev')">
          <i class="fas fa-chevron-left ui-g-float-right md-hide sm-hide xs-hide left"></i>
        </a>
        
        <a v-on:click="nextClient('next')" class="mobile">
          <i class="fas fa-chevron-right ui-g-float-right xl-hide lg-hide right mobile"></i>
        </a>
        <a v-on:click="nextClient('prev')" class="mobile">
          <i class="fas fa-chevron-left ui-g-float-right xl-hide lg-hide left mobile"></i>
        </a>
      </div>

      <div class="popup-body ui-g-12" ref="testElement">
        <div
          class="ui-g-12 hero"
          v-bind:class="{
				qx50 : $router.currentRoute.path === '/infiniti-usa-2019-QX50',
				nissan : $router.currentRoute.path === '/nissan-usa-2018-leaf',
				mazdaWinter : $router.currentRoute.path === '/mazda-canada-winter-sales-event',
				mazdaSummer : $router.currentRoute.path === '/mazda-canada-summer-sales-event',
				ally : $router.currentRoute.path === '/ally-bank-surprise-and-delight',
				bcbs : $router.currentRoute.path === '/blue-cross-healthy-blue-xtras',
				exclusiviti : $router.currentRoute.path === '/infiniti-usa-exclusiviti',
				trender : $router.currentRoute.path === '/tender-birmingham',
				nissanUSA2019 : $router.currentRoute.path === '/nissan-usa-2019-altima',
				mazdaClubhousePrivileges : $router.currentRoute.path === '/mazda-canada-clubhouse-privileges'
			}"
        ></div>

        <div class="body-container">
          <div class="ui-g-3 ui-md-12 ui-sm-12 about-us-cont">
            <h2 class="title">Client + Project</h2>
          </div>

          <div class="ui-g-9 ui-md-12 ui-sm-12 about-us-cont">
            <h2 class="black">{{popupData.header}}</h2>
            <h3 class="gray">{{popupData.subHeader}}</h3>
          </div>

          <div class="ui-g-12 ui-g-center">
            <hr class="break popup-adjusted-margins">
          </div>

          <div class="ui-g-3 ui-md-12 ui-sm-12 about-us-cont">
            <h2 class="title">Overview</h2>
          </div>

          <div class="ui-g-9 ui-md-12 ui-sm-12 about-us-cont">
            <p class="popup-paragraph">{{popupData.overview}}</p>
          </div>

          <div class="ui-g-12 ui-md-12 ui-sm-12 ui-g-center popup-img-cont">
            <span v-for="image in popupData.img" :key="image">
              <img :src="'static/images/' + image">
            </span>
          </div>

          <div class="ui-g-12 ui-g-center">
            <img src="static/hmg-logos/HMG-stamp@2x.png" class="stamp-logo">
          </div>
        </div>

        <div class="ui-g-12 ui-g-center pg-top-link popup">
          <a href="#" v-on:click="scrollTo()">Back to Top</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Request from "@/rest/gets.js";
import VueScrollTo from "vue-scrollto";

export default {
  name: "Popup",
  data: () => ({
    popupData: {},
    request: new Request(),
    options: {},
    routes: [
      {
        path: "/mazda-canada-clubhouse-privileges",
        class: "mazdaClubhousePrivileges"
      },
      {
        path: "/nissan-usa-2019-altima",
        class: "nissanUSA2019"
      },
      {
        path: "/infiniti-usa-2019-QX50",
        class: "qx50"
      },
      {
        path: "/nissan-usa-2018-leaf",
        class: "nissan"
      },
      {
        path: "/mazda-canada-winter-sales-event",
        class: "mazdaWinter"
      },
      {
        path: "/tender-birmingham",
        class: "trender"
      },
      {
        path: "/mazda-canada-summer-sales-event",
        class: "mazdaSummer"
      },
      {
        path: "/ally-bank-surprise-and-delight",
        class: "ally"
      },
      {
        path: "/blue-cross-healthy-blue-xtras",
        class: "bcbs"
      },
      {
        path: "/infiniti-usa-exclusiviti",
        class: "exclusiviti"
      }
    ]
  }),
  created() {
    this.getData();
  },
  methods: {
    scrollTo() {
      this.options = {
        container: this.$refs["testElement"],
        easing: "ease-in",
        offset: -60,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
      };

      VueScrollTo.scrollTo(this.$refs["popupTop"], 500, this.options);
    },
    getData() {
      setTimeout(() => {
        try {
          var body = document.getElementsByTagName("BODY")[0];
          body.classList.add("hideScroll");
          ga("send", "pageview", location.pathname);
          var vtsrc =
              ("https:" == document.location.protocol
                ? "https://"
                : "http://") +
              "code.visitor-track.com/vt2.aspx?v=6&id=" +
              vtid.toString() +
              "&r=" +
              escape(document.referrer) +
              "&u=" +
              escape(document.URL),
            n = document.createElement("script"),
            e = document.getElementsByTagName("script")[0];
          (n.async = !0), (n.src = vtsrc), e.parentNode.insertBefore(n, e);
        } catch (e) {}
      }, 10);
      this.request
        .getPopupData()
        .then(res => {
          const currentRoute = this.routes.find(
            route => route.path === this.$router.currentRoute.path
          );
          if (currentRoute) {
            this.popupData = res.data[currentRoute.class];
          }
        })
        .catch(e => console.log(e));
    },
    close() {
      setTimeout(() => {
        var body = document.getElementsByTagName("BODY")[0];
        body.classList.remove("hideScroll");
      }, 10);

      this.$router.push("/");
    },
    nextClient(flag) {
      // Find index of current route
      const currentRoute = this.routes.find(
        route => route.path === this.$router.currentRoute.path
      );
      const currentIndex = this.routes.indexOf(currentRoute);

      if (flag === "prev") {
        // If current route is first, go to end of routes; otherwise just go back one
        const prevIndex =
          currentIndex === 0 ? this.routes.length - 1 : currentIndex - 1;
        this.$router.push(this.routes[prevIndex].path);
      } else if (flag === "next") {
        // If current route is last, go to beginning; otherwise just go forward one
        const nextIndex =
          currentIndex === this.routes.length - 1 ? 0 : currentIndex + 1;
        this.$router.push(this.routes[nextIndex].path);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.popup-body {
  -webkit-overflow-scrolling: touch;
  /* position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0; */
  overflow: auto;
  height: 100%;
  width: 100%; /* added to fix width issue */
  background: white;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* overflow: auto; */
  /* background-color: white; */
  transition: top 0.5s ease;
}

/*
	* The following styles are auto-applied to elements with
	* transition="modal" when their visibility is toggled
	* by Vue.js.
	*
	* You can easily play with the modal transition by editing
	* these styles.
	*/
.modal-enter {
  top: 100%;
  width: 100%;
  overflow: hidden;
}

.modal-leave-active {
  top: 100%;
  width: 100%;
  overflow: hidden;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  /* -webkit-transform: scale(1.1);
		transform: scale(1.1); */
}

.modal-enter .banner,
.modal-leave-active .banner {
  opacity: 0;
  /* transform: translate(0px, -80px); */
}

.modal-enter .popup-body,
.modal-leave-active .popup-body {
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/Popup.vue